<template>
	<div class="c-dashboard__wrap" v-if="currentDate"
        :data-component-name="$options.name"
	>
        <StaffView
            :currentDate="currentDate"
            @set-current-date="$emit('set-current-date', $event)"
            @set-current-view="$emit('set-current-view', $event)"
            @jump-to-project-week="jumpToProjectWeek($event)"
        />
	</div>
</template>

<script>
    import StaffView from '@/components/dashboard/StaffView';

	export default {
		name: "Staffs",
        components: {
            StaffView
		},
		props: {
			currentDate: {
                type: String,
                default: null
            },
		},
		data(){
			return {
			}
		},
		methods: {
		},
		mounted(){
		},
        // apollo: {
		// }
	}
</script>
<style lang="scss" scoped>
	@import "@/scss/views/Dashboard.scss";
</style>

<style lang="scss">
	.schedule{
		background-color: white;
		height: 100%;
		display: flex;
		flex-direction: column;
		padding: 60px;
	}
</style>